import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const ArticleViewContent = lazy(() => import('../../../components/Pages/Articles/[articleId]'));

export default function ArticleView(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Article View page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <ArticleViewContent />
      </Suspense>
    </Layout>
  );
}
